import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import '../static/less/new_shopping_cart/new_shopping_cart_mobile_header.css';
import { IconComponent } from './ds/atoms/icons/iconComponent';
import { setOpenReservationDetails } from '../actions/Session';
import { MULTIPLE_ROOMS } from '../constants';
import { selectCurrentRoomText } from './booking/utils';

const NewShoppingCartMobileHeader = (props, context) => {
  const scrollDownToTopOfElement = (className) => {
    const element = document.querySelector(`.${className}`);
    if (element) {
      // Obtener la posición del elemento en relación al documento
      const position = element.getBoundingClientRect().top;
      // Hacer scroll hasta esa posición
      window.scrollTo({
        top: position,
        behavior: 'smooth', // Añadir efecto suave
      });
    }
  };

  const onChangeOpenReservationDetails = () => {
    props.dispatch(setOpenReservationDetails(!props.openReservationDetails));
  };

  useEffect(() => {
    if (props.openReservationDetails) {
      scrollDownToTopOfElement('mainContainer');
    }
  }, [props.openReservationDetails]);

  if (selectCurrentRoomText(props, context) === '' || window.location.pathname === '/thanks/'
    || window.location.pathname === '/booking-detail/') {
    return (
            <div className="new_shopping_cart_mobile_header_header-container">
              <div className="new_shopping_cart_mobile_header_reservation-details2"
                onClick={() => onChangeOpenReservationDetails()}>
                {context.t('RESERVATION DETAILS')}
                <IconComponent icon={props.openReservationDetails === true ? 'chevron-up' : 'chevron-down'}
                className="new_shopping_cart_mobile_header_chevron-icon"/>
              </div>
            </div>
    );
  }

  return (
      <div className="new_shopping_cart_mobile_header_header-container">
        <div className="new_shopping_cart_mobile_header_title">
            {selectCurrentRoomText(props, context)}
        </div>
        <div className="new_shopping_cart_mobile_header_reservation-details"
          onClick={() => onChangeOpenReservationDetails()}>
          {context.t('RESERVATION DETAILS')}
          <IconComponent icon={props.openReservationDetails === true ? 'chevron-up' : 'chevron-down'}
          className="new_shopping_cart_mobile_header_chevron-icon"/>
        </div>
      </div>
  );
};

NewShoppingCartMobileHeader.propTypes = {
};

NewShoppingCartMobileHeader.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default connect((state) => ({
  openReservationDetails: state.session.openReservationDetails,
  currentRoomId: state.booking.multipleRoomStep || MULTIPLE_ROOMS.FIRST,
  distributions: state.bookingFormState.distributions,
  multipleRoomSelection: state.booking.multipleRoomSelection,
  isEditingBooking: state.booking.isEditingBooking,
}))(NewShoppingCartMobileHeader);
